import { BlockTokenType } from "./mdDef.js";
import { extractColorToken, getColorConfig } from "../mdTheme.js";

const isOrderedMarker = (marker_) => /^\d/.test(marker_);

export function collectList(lines_, startIndex_) {
  const list_marker_regex = /^(\s*)([*+-]|\d+[.)])\s+(.*)$/;
  const items = [];
  let index = startIndex_;
  const firstMatch = lines_[startIndex_].match(list_marker_regex);
  if (!firstMatch) {
    return null;
  }
  const baseIndent = firstMatch[1].length;
  const ordered = isOrderedMarker(firstMatch[2]);
  const startNumber = ordered ? parseInt(firstMatch[2], 10) || 1 : 1;
  let currentItem = null;
  let currentContentIndent = firstMatch[0].length - firstMatch[3].length;

  while (index < lines_.length) {
    const line = lines_[index];
    const trimmed = line.trim();

    if (!trimmed) {
      let nextIndex = index + 1;
      while (nextIndex < lines_.length && !lines_[nextIndex].trim()) {
        nextIndex += 1;
      }
      if (nextIndex >= lines_.length) {
        break;
      }
      const nextLine = lines_[nextIndex];
      const nextMarkerMatch = nextLine.match(list_marker_regex);
      const nextIndent = nextLine.match(/^\s*/)[0].length;
      const nextIsListItem =
        nextMarkerMatch &&
        nextIndent === baseIndent &&
        isOrderedMarker(nextMarkerMatch[2]) === ordered;
      const nextIsContinuation = !nextMarkerMatch && nextIndent > baseIndent;
      if (!nextIsListItem && !nextIsContinuation) {
        break;
      }
      if (currentItem) {
        currentItem.lines.push("");
      }
      index += 1;
      continue;
    }

    const markerMatch = line.match(list_marker_regex);
    if (markerMatch) {
      const indent = markerMatch[1].length;
      const markerOrdered = isOrderedMarker(markerMatch[2]);

      if (indent < baseIndent) {
        break;
      }

      if (indent === baseIndent && markerOrdered === ordered) {
        if (currentItem) {
          items.push({
            lines: currentItem.lines,
          });
        }
        currentContentIndent = line.length - markerMatch[3].length;
        currentItem = {
          lines: [markerMatch[3]],
          contentIndent: currentContentIndent,
        };
        index += 1;
        continue;
      }
    }

    if (!currentItem) {
      break;
    }

    const indentWidth = line.match(/^\s*/)[0].length;
    if (indentWidth <= baseIndent) {
      break;
    }

    const sliceStart = Math.min(
      line.length,
      currentItem.contentIndent ?? currentContentIndent
    );
    currentItem.lines.push(line.slice(sliceStart));
    index += 1;
  }

  if (currentItem) {
    items.push({
      lines: currentItem.lines,
    });
  }

  if (items.length === 0) {
    return null;
  }

  const normalizedItems = items.map((entry) => {
    const content = entry.lines.join("\n");
    const { text, token } = extractColorToken(content);
    const hasColor = token && getColorConfig(token);
    return {
      content: hasColor ? text : content,
      color: hasColor ? token : null,
    };
  });

  return {
    type: ordered ? BlockTokenType.ORDERED_LIST : BlockTokenType.UNORDERED_LIST,
    ordered: ordered,
    items: normalizedItems,
    nextIndex: index,
    start: startNumber,
  };
}
